import styled from 'styled-components';

export const StyledTextArea = styled.textarea``;

export const StyledTextBlock = styled.div``;
